import React from 'react';
import {
    Modal,
    Grid,
    Typography,
    Box
} from '@mui/material';
import { bindActionCreators, Dispatch } from 'redux';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import { closeCanvasRedirectModal } from '../../redux/actions';
import { isCanvasRedirectModalOpenSelector } from '../../redux/selectors';

import MuiTheme from '../../templates/StaffTools/mui-theme';

const mapStateToProps = createSelector(
    isCanvasRedirectModalOpenSelector,
    (show: boolean) => ({
        show
    })
);

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            closeCanvasRedirectModal
        },
        dispatch
    );

type CanvasRedirectModalProps = {
    closeCanvasRedirectModal: () => void;
    show: boolean;
};

function CanvasRedirectModal(props: CanvasRedirectModalProps): JSX.Element {
    const { show, closeCanvasRedirectModal } = props;

    const handleModalHide = () => {
        closeCanvasRedirectModal();
    }
    console.log(show)

    return (
        <MuiTheme>
            <Modal
                open={show}
                onClose={handleModalHide}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                aria-labelledby="canvas-redirect-modal"
                aria-describedby="canvas-redirect-modal-description"
            >
                <Box className='modal-pcc'>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="h2" textAlign="center" paddingBottom={5}>Go to Canvas?</Typography>
                        <Typography variant="body1" textAlign="center" paddingBottom={5}>Canvas is where your grades and assignments will be stored! If you don't know what Canvas is, or you're not sure, you should click the back button.</Typography>
                        {/* gotta make the buttons fill the whole thing on xs */}
                        <Grid container justifyContent="center" alignItems="center" spacing={2}>
                            <Grid item xs={12} lg={4} xl={3}>
                                <button 
                                    style={{ 
                                        padding: '1vmin 2vmin', 
                                        width: '100%'
                                    }} 
                                    className='btn-danger'
                                    onClick={handleModalHide}
                                >
                                    Go Back
                                </button>
                            </Grid>
                            <Grid item xs={12} lg={4} xl={3} justifyContent="center">
                                <a href="https://persevere.instructure.com/login/saml/105">
                                <button style={{ padding: '1vmin 2vmin', width: '100%'}}>Go to Canvas!</button>
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                </Box>
            </Modal>
        </MuiTheme>
    );
}

CanvasRedirectModal.displayName = 'Canvas Redirect Modal';

export default connect(mapStateToProps, mapDispatchToProps)(CanvasRedirectModal);